Controller.$inject = [];

function Controller() {

}

export function HuiTable() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            isStriped: '<',
            isHoverable: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <table class="hui hui-table"
                   ng-class="{
                        'table-striped': $huiCtrl.isStriped,
                        'table-hover': $huiCtrl.isHoverable
                   }"
                   ng-transclude>
                </table>
            `;
        }
    }
}